import React from 'react'
import SupportTicketContainer from '../../../Components/Miscellaneous/SupportTicket'

export default function SupportTicket() {
    return (
        <div className='page-body'>
            <SupportTicketContainer />
        </div>
    )
}
